import { Link } from 'react-router-dom'
import { Header, Footer, Container } from '../components'
import { Book, ExternalLink, Code2, FileCode } from 'lucide-react'

interface DocLinkProps {
  title: string
  description: string
  href: string
  icon: React.ReactNode
}

function DocLink({ title, description, href, icon }: DocLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-start gap-4 p-6 bg-white border border-slate-200 rounded-lg hover:border-primary-300 hover:shadow-md transition-all group"
    >
      <div className="p-3 bg-primary-50 text-primary-600 rounded-lg group-hover:bg-primary-100 transition-colors">
        {icon}
      </div>
      <div className="flex-1">
        <div className="flex items-center gap-2">
          <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
          <ExternalLink className="w-4 h-4 text-slate-400" />
        </div>
        <p className="text-slate-500 mt-1">{description}</p>
      </div>
    </a>
  )
}

export default function DocsPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      <Header />
      <main className="flex-1 pt-32 pb-20">
        <Container>
          <div className="max-w-3xl mx-auto">
            {/* Header */}
            <div className="text-center mb-12">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-primary-500/10 border border-primary-500/20 mb-6">
                <Book className="w-4 h-4 text-primary-600" />
                <span className="text-sm text-primary-600 font-medium">Documentation</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
                Get Started with Falcon
              </h1>
              <p className="text-lg text-slate-500">
                Choose your language to see integration examples.
              </p>
            </div>

            {/* SDK Links */}
            <div className="grid gap-4 mb-12">
              <DocLink
                title="JavaScript / Node.js"
                description="Express.js and browser integration"
                href="https://github.com/roselabs-io/examples/tree/main/falcon-js"
                icon={<Code2 className="w-6 h-6" />}
              />
              <DocLink
                title="Python"
                description="FastAPI and Flask integration"
                href="https://github.com/roselabs-io/examples/tree/main/falcon-python"
                icon={<FileCode className="w-6 h-6" />}
              />
              <DocLink
                title="React"
                description="Error boundary component"
                href="https://github.com/roselabs-io/examples/tree/main/falcon-react"
                icon={<Code2 className="w-6 h-6" />}
              />
              <DocLink
                title="Next.js"
                description="App Router integration"
                href="https://github.com/roselabs-io/examples/tree/main/falcon-nextjs"
                icon={<Code2 className="w-6 h-6" />}
              />
            </div>

            {/* CTA */}
            <div className="text-center">
              <Link
                to="/signup"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-medium rounded-lg transition-colors"
              >
                Get Started Free
              </Link>
            </div>
          </div>
        </Container>
      </main>
      <Footer />
    </div>
  )
}
